import React, { useState } from "react";
import {
  FormDropdown,
  InputField,
} from "../../../../components/Stepper/fields/inputField";

const StructureForm = ({ onSubmit, groupsData }) => {
  const [structureData, setStructureData] = useState({
    name: "",
    inclusion: groupsData[0] || null,
  });

  const [formErrors, setFormErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      onSubmit(structureData);
    } else {
      setFormErrors(errors);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!structureData.name) errors.name = "Name is required";
    if (!structureData.inclusion) errors.inclusion = "Included In are required";
    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStructureData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-13rem)]">
      <h2 className="text-2xl font-semibold mb-6 text-lightPrimary dark:text-primary-gradient">
        General
      </h2>
      <form onSubmit={handleSubmit} className="flex flex-col flex-grow">
        <div className="grid md:grid-cols-2 gap-5 text-primary mb-8 md:flex-grow">
          <InputField
            label="Name*"
            placeholder="Enter your name"
            name="name"
            value={structureData.name}
            onChange={handleInputChange}
            required={true}
            errors={formErrors.name}
          />

          <FormDropdown
            label="Include In*"
            value={structureData.inclusion}
            name="inclusion"
            onChange={handleInputChange}
            options={groupsData}
            optionsLabel="name"
            error={formErrors.inclusion}
            className={`w-full bg-transparent border border-info dark:border-gray-300 rounded-lg ${
              structureData.inclusion ? "asset_Dropdown" : ""
            }`}
            containerClassName="col-span-2"
            labelClassName="block mb-2 text-lg text-info dark:text-grey font-semibold"
            mainClassName="w-full"
            placeholder="Select include In"
          />
        </div>

        <div className="mt-auto flex md:justify-end justify-center">
          <button
            type="submit"
            className="px-6 py-2 dark:text-black bg-lightPrimary text-white dark:button-primary-gradient hover:bg-secondary rounded-lg"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default StructureForm;
